import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DisplayObject} from "pixi.js";
import {TrueGritStatics} from "../TrueGritStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

/**
 * Created by Jerker Nord on 2021-07-16.
 */

export class TrueGritWinPresentations extends PIXI.Container implements StageLayer {

    constructor() {
        super();
        this.name = "TrueGritWinPresentations";
        this.onResize();
    }

    onResize():void {
        this.position = TrueGritStatics.MAIN_REELS_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }

    public addToLayer(object:DisplayObject, reel:number, reelPosition:number):void {
        object.position.x = TrueGritStatics.symbolWidth * reel;
        object.position.y = TrueGritStatics.symbolHeight * reelPosition;
        this.addChild(object);
    }
}